import React from "react";
import { useTranslation } from "react-i18next";
import PluxeeForm from "./PluxeeForm"; // Import the new form

interface PaymentMethodsProps {
  availableMethods: string[];
  selectedMethodId: string | null;
  onMethodSelect: (methodId: string) => void;
  // --- ADD NEW PROPS ---
  onPluxeeFormChange: (data: { gsm: string; otp: string }) => void;
  onPluxeeFormValidityChange: (isValid: boolean) => void;
}

const PaymentMethods: React.FC<PaymentMethodsProps> = ({
  availableMethods,
  selectedMethodId,
  onMethodSelect,
  // --- DESTRUCTURE NEW PROPS ---
  onPluxeeFormChange,
  onPluxeeFormValidityChange,
}) => {
  const { t } = useTranslation();

  if (!availableMethods || availableMethods.length === 0) {
    return (
      <p className="payment-methods-unavailable">
        {t(
          "checkout.errors.noPaymentMethodsAvailable",
          "No payment methods are available."
        )}
      </p>
    );
  }

  return (
    <div className="payment-methods">
      {availableMethods.map((methodId) => {
        const title = t(`checkout.payment.${methodId}.title`, methodId);
        const description = t(`checkout.payment.${methodId}.description`, "");
        const tooltipId = `payment-tooltip-${methodId}`;
        const isSelected = selectedMethodId === methodId;

        return (
          <div
            key={methodId}
            className={`payment-option ${isSelected ? "selected" : ""}`}
            // No onClick on the main div, rely on label/input
          >
            <label>
              <input
                type="radio"
                name="payment_method"
                value={methodId}
                checked={isSelected}
                onChange={() => onMethodSelect(methodId)}
                aria-labelledby={`payment-title-${methodId}`}
              />
              <span id={`payment-title-${methodId}`} className="payment-title">
                {title}
              </span>
              {description && (
                <span
                  className="payment-tooltip-container"
                  aria-describedby={tooltipId}
                >
                  <span className="payment-help-icon" aria-hidden="true">
                    ?
                  </span>
                  <span
                    className="payment-tooltip"
                    id={tooltipId}
                    role="tooltip"
                  >
                    {description}
                  </span>
                </span>
              )}
            </label>
            {/* Conditionally render the Pluxee form */}
            {methodId === "pluxee_otp" && isSelected && (
              <PluxeeForm
                onFormChange={onPluxeeFormChange}
                onValidityChange={onPluxeeFormValidityChange}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PaymentMethods;
